// @flow
import React, { Component } from 'react';
import {
  BasicInfoP,
  BasicInfoAccountImg,
  BasinInfoLineDiv,
  BasicInfoCard,
  BasicInfoContentDiv,
  ChangePasswordP
} from './InformationStyles';
import { type Partner } from '../../../utilities/types';

import accountImage from '../../../assets/icons/account-blue.png';
import { Default } from '../../../components/Responsive';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  partner: Partner,
  toggleEdit: () => void
};

export default class BasicInfoBlock extends Component<Props> {
  render() {
    return (
      <BasicInfoCard onClick={this.props.toggleEdit}>
        <Default>
          <BasicInfoAccountImg src={accountImage} />
        </Default>
        <BasicInfoContentDiv>
          <BasinInfoLineDiv>
            <h5>Name</h5>
            <BasicInfoP>{this.props.partner.first_name}</BasicInfoP>
          </BasinInfoLineDiv>
          <BasinInfoLineDiv>
            <h5>Email</h5>
            <BasicInfoP>{this.props.partner.email}</BasicInfoP>
          </BasinInfoLineDiv>
          <BasinInfoLineDiv>
            <h5>Password</h5>
            <BasicInfoP disabled>**************</BasicInfoP>
            <ChangePasswordP>
              <DefaultIcon name="edit" />
              Change Password
            </ChangePasswordP>
          </BasinInfoLineDiv>
        </BasicInfoContentDiv>
      </BasicInfoCard>
    );
  }
}
